/* eslint-disable no-nested-ternary */
// Dependecies
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Accordion } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Moment from 'react-moment';
import moment from 'moment';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import { Pagination } from 'antd';
import 'antd/dist/antd.css';
import { withTranslation } from 'react-i18next';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

// Component
import Template from '../../components/Template';
import PopUp from '../../components/Modal';
import Spinner from '../../components/Spinner';
import RenderTooltip from '../../components/RenderTooltip';
import ModalImage from '../../components/ModalImage';
import FixedJobRequest from '../../components/JobRequest';

// Hooks
import useMaintenaceCompany from '../../hooks/useMaintenaceCompany';

// Images
import arrowDown from '../../../sass/images/icons/arrow-down.svg';
import arrowUp from '../../../sass/images/icons/arrow-up.svg';
import alertIcon from '../../../sass/images/icons/modal-alert.svg';
import notMaintenance from '../../../sass/images/not-maintenance.svg';
import search from '../../../sass/images/icons/search.svg';
import close from '../../../sass/images/icons/cerrar.svg';
import check from '../../../sass/images/icons/check.svg';
import infoAlert from '../../../sass/images/alert/info-alert.svg';
import eye from '../../../sass/images/ver-ocultar.svg';

// Utils
import { urlPublicS3 } from '../../helpers';

function Maintenance(props) {
const [activeKey, setActiveKey] = useState(0);
const {
  reloadCompany,
  maintenancesCompany,
  newMaintenancesCompany,
  maintenancesBoolCompany,
  openModal,
  openModalCancel,
  openModalStarsInvert,
  openModalRequestReject,
  openModalImage,
  closeModal,
  acceptModal,
  cancelService,
  idService,
  onSubmit,
  onSubmitStartCompany,
  star,
  setStar,
  CustomToggle,
  confirmCancel,
  searchLicensePlate,
  imagen,
  valuePlate,
  setValuePlate,
  messageAlert,
  aproveService,
  redirectJobRequest,
  urlImageService,
  setSuccessfully,
} = useMaintenaceCompany();

const { t } = props;
const [currentPage, setCurrentPage] = useState(1);
const [cardPerPage] = useState(6);
const [minIndex, setMinIndex] = useState(0);
const [maxIndex, setMaxIndex] = useState(cardPerPage);

// change page
const handleChange = (page) => {
  setCurrentPage(page);
  setMinIndex((page - 1) * cardPerPage);
  setMaxIndex(page * cardPerPage);
};
const hourChange = (time) => moment(time, 'hh:mm a');

return (
  <Template
    type={4}
    newMaintenances={newMaintenancesCompany}
    classNameContainer="maintenance"
    className="container_menu maintenance"
  >
    <>
      {openModal ? (
        <PopUp
          open={openModal}
          close={closeModal}
          icon={alertIcon}
          title={t('title-open-modal')}
          back={t('cancel')}
          go={t('yes-accept')}
          accept={acceptModal}
          modalDesign
          btnAccept
          btnClose
          classNameContent="modal-confirm"
          classNameBtn="btn_modal pink"
        />
      ) : (
        ''
      )}

      {openModalCancel ? (
        <PopUp
          open={openModalCancel}
          close={closeModal}
          icon={alertIcon}
          title={t('title-open-modal-cancel')}
          back={t('keep-it')}
          go={t('yes-cancel')}
          accept={cancelService}
          modalDesign
          btnAccept
          btnClose
          classNameContent="modal-confirm"
          classNameBtn="btn_modal pink"
        />
      ) : (
        ''
      )}

      {openModalStarsInvert ? (
        <PopUp
          open={openModalStarsInvert}
          close={closeModal}
          icon=""
          title={t('maintenanceCompany:title-open-modal-star')}
          go={t('maintenanceCompany:go-modal-star')}
          modalDesign
          classNameContent="modal-confirm-star"
          showQuestionStarInvert
          idService={idService}
          onSubmitSatisfactionQuestionnaire={onSubmitStartCompany}
          star={star}
          setStar={setStar}
        />
      ) : (
        ''
      )}
      {openModalRequestReject ? (
        <PopUp
          open={openModalRequestReject}
          close={closeModal}
          icon={alertIcon}
          title={t('title-modal-request-reject')}
          description={t('description-modal-request-reject')}
          back={t('keep-it')}
          go={t('confirm')}
          modalDesign={false}
          btnAccept={false}
          btnClose={false}
          classNameContent="modal-left"
          classNameBtn="btn_modal pink"
          showQuestion
          question={t('question')}
          answers={[t('answer'),t('answer-two')]}
          idService={idService}
          onSubmit={onSubmit}
        />
      ) : (
        ''
      )}
      {openModalImage ? (
        <ModalImage isBlocked={openModalImage} close={closeModal} urlImage={urlImageService} />
      ) : (
        ''
      )}

      {!reloadCompany ? (
        <Spinner text={t('alert:reload')}> </Spinner>
      ) : (
        <>
          <FixedJobRequest />
          {maintenancesBoolCompany === 0 ? (
            <>
              <div className="content_dynamic history company-block">
                <Row className="content_history">
                  <div className="header-content">
                    <div className="info-tittle">
                      <h1 className="title-maintenances">{t('title')}</h1>
                    </div>
                  </div>
                  <div className="not-services">
                    <img
                      src={notMaintenance}
                      className="img-not-maintenances"
                      alt={t('alt:not_mantenice')}
                    />
                    <h4 className="center">{t('maintenanceCompany:alert-not')}</h4>
                    <p className="center">{t('maintenanceCompany:alert-not2')}</p>
                  </div>
                </Row>
              </div>
            </>
          ) : (
            <>
              <FixedJobRequest />
              <div className="content_dynamic history company-block">
                <Row className="content_maintenace">
                  <div className="header-content">
                    <div className="info-tittle">
                      <h1 className="title-maintenances">{t('maintenanceCompany:title')}</h1>
                      <p>{t('maintenanceCompany:description')}</p>
                    </div>
                  </div>
                  <div className="convention-services">
                    <div className="type-status">
                      <p className="bold txt">{t('status')}</p>
                      <div className="content-status company">
                        <p>
                          <span className="circle status-1" /> {t('unassigned')}
                        </p>
                        <p>
                          <span className="circle status-2" /> {t('assigned')}
                        </p>
                        <p>
                          <span className="circle status-3" /> {t('in-progress')}
                        </p>
                        <p>
                          <span className="circle status-10" /> {t('in-approval')}
                        </p>
                        <p>
                          <span className="circle status-11" /> {t('approved')}
                        </p>  
                        <p>
                          <span className="circle status-4" /> {t('finalized')}
                        </p>
                        <p>
                          <span className="circle status-5" /> {t('cancelled')}
                        </p>
                      </div>
                    </div>
                    <div className="modal-display company-content row-states">
                      <input
                        className="input_search form-control"
                        placeholder={t('search-plate')}
                        id="search-plate"
                        name="search-plate"
                        type="text"
                        value={valuePlate || ''}
                        onChange={(e) => {
                          setValuePlate(e.target.value.toUpperCase());
                        }}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          imagen === check
                            ? searchLicensePlate(valuePlate, close)
                            : searchLicensePlate('', check)
                        }
                      >
                        <img src={valuePlate ? imagen : search} alt={t('alt:search')} />
                      </button>
                    </div>
                  </div>
                </Row>
                <Row className="no-gutters">
                  {maintenancesCompany.length <= 0 ? (
                    <div className="content_not_mantenaice company">
                      <img
                        src={notMaintenance}
                        className="img-not-maintenances small"
                        alt={t('alt:not_mantenice')}
                      />
                      <h4>
                        {t('not-maintenance')} {valuePlate}
                      </h4>
                      <Button
                        className="btn-orange"
                        style={{ width: '250px', padding: '0px' }}
                        variant="light"
                        onClick={() => searchLicensePlate('', check)}
                      >
                        {t('buttom-alert2')}
                      </Button>
                    </div>
                  ) : (
                    <>
                      <Accordion className="col-12">
                        {maintenancesCompany.map(
                          (maintenance, index) =>
                            index >= minIndex &&
                            index < maxIndex && (
                              <div key={index}>
                                {maintenance.read && maintenance.id_status === 3 ? (
                                  <div className="circle2 read spacy-read" />
                                ) : (
                                  ''
                                )}
                                <Card className="main-card" key={maintenance.id} PageItem>
                                  <div
                                    className={`borde-status status-${maintenance.id_status}`}
                                  />
                                  <Card.Header
                                    className={`card-maintenances ${
                                      activeKey === maintenance.id ? 'head-show' : 'head-hidden'
                                    }`}
                                  >
                                    <Row>
                                      <Col
                                        className="col-head"
                                        xs={6}
                                        sm={3}
                                        md={3}
                                        lg={3}
                                        xl={4}
                                      >
                                        <div className="arrow-card">
                                          <p className="title-2">{t('license-plate')}</p>

                                          <p className="txt">
                                            {maintenance.licenseplate}
                                            <OverlayTrigger
                                              placement="top"
                                              className="tooltip-info vehicle"
                                              id="vehicle"
                                              delay={{ show: 50, hide: 500 }}
                                              overlay={(componentProps) =>
                                                RenderTooltip({
                                                  ...componentProps,
                                                  text: `${t('brand')}`,
                                                  text2: `${t('model')}`,
                                                  text3: `${t('color')}`,
                                                  brand: maintenance.brand,
                                                  model: maintenance.model,
                                                  color: maintenance.color,
                                                  id: 'tooltip-info-vehicle',
                                                  classtxt: 'tooltip-txt-info',
                                                })
                                              }
                                            >
                                              <img
                                                className="info-maintenance-company"
                                                src={eye}
                                                alt={t('alt:tooltip')}
                                              />
                                            </OverlayTrigger>
                                          </p>
                                        </div>
                                      </Col>
                                      <Col
                                        className="col-head"
                                        xs={6}
                                        sm={3}
                                        md={3}
                                        lg={3}
                                        xl={4}
                                      >
                                        <CustomToggle
                                          as={Button}
                                          eventKey={
                                            maintenance.id_status !== 5 ? maintenance.id : null
                                          }
                                          handleClick={() => {
                                            if (activeKey === maintenance.id) {
                                              setActiveKey(null);
                                            } else {
                                              setActiveKey(maintenance.id);
                                            }
                                          }}
                                        >
                                          <p className="title-2">{t('date-hour-request')}</p>
                                          <p className="txt">
                                            <Moment format="DD/MM/YYYY hh:mm a">
                                              {maintenance.created_at}
                                            </Moment>
                                          </p>
                                        </CustomToggle>
                                      </Col>
                                      <Col
                                        className="col-head"
                                        xs={6}
                                        sm={3}
                                        md={3}
                                        lg={3}
                                        xl={4}
                                      >
                                        <CustomToggle
                                          as={Button}
                                          eventKey={
                                            maintenance.id_status !== 5 ? maintenance.id : null
                                          }
                                          handleClick={() => {
                                            if (activeKey === maintenance.id) {
                                              setActiveKey(null);
                                            } else {
                                              setActiveKey(maintenance.id);
                                            }
                                          }}
                                        >
                                          <p className="title-2">
                                            {t('maintenanceCompany:id-service')}
                                          </p>
                                          <p className="txt">{maintenance.id}</p>
                                        </CustomToggle>
                                      </Col>
                                      <Col
                                        className="col-head"
                                        xs={6}
                                        sm={3}
                                        md={3}
                                        lg={3}
                                        xl={4}
                                      >
                                        <CustomToggle
                                          as={Button}
                                          eventKey={
                                            maintenance.id_status !== 5 ? maintenance.id : null
                                          }
                                          handleClick={() => {
                                            if (activeKey === maintenance.id) {
                                              setActiveKey(null);
                                            } else {
                                              setActiveKey(maintenance.id);
                                            }
                                          }}
                                        >
                                          <p className="title-2">{t('status-service')}</p>
                                          <p
                                            className={`txt-status txt color-${maintenance.id_status}`}
                                          >
                                            {maintenance.status.status}
                                          </p>
                                        </CustomToggle>
                                      </Col>
                                      <Col className="toggle-matenaice">
                                        {maintenance.id_status !== 5 ? (
                                          maintenance.id_status !== 4 ? (
                                            maintenance.id_status !== 3 ? (
                                              <Button
                                                className="btn-cancel"
                                                onClick={() => confirmCancel(maintenance.id)}
                                              >
                                                {t('cancel-service')}
                                              </Button>
                                            ) : (
                                              ''
                                            )
                                          ) : (
                                            <>
                                              {maintenance.company_observations === null ? (
                                                <Button
                                                  className="btn-option aprobe company-button"
                                                  onClick={() => {
                                                    aproveService(maintenance.id);
                                                    setSuccessfully(true);
                                                  }}
                                                >
                                                  {t('approve-service')}
                                                </Button>
                                              ) : (
                                                ''
                                              )}
                                            </>
                                          )
                                        ) : (
                                          <Button
                                            className="btn-option redirect company-button"
                                            onClick={() =>
                                              redirectJobRequest(t('routers:JobRequests'))
                                            }
                                          >
                                            {t('reschedule-job')}
                                          </Button>
                                        )}
                                      </Col>
                                      {maintenance.id_status !== 5 ? (
                                        <div className="toggle-icon">
                                          <CustomToggle
                                            as={Button}
                                            eventKey={
                                              maintenance.id_status !== 5 ? maintenance.id : null
                                            }
                                            handleClick={() => {
                                              if (activeKey === maintenance.id) {
                                                setActiveKey(null);
                                              } else {
                                                setActiveKey(maintenance.id);
                                              }
                                            }}
                                          >
                                            {activeKey === maintenance.id ? (
                                              <img
                                                className="img-arrow-last"
                                                src={arrowUp}
                                                alt={t('alt:hidden_information')}
                                              />
                                            ) : (
                                              <img
                                                className="img-arrow-last"
                                                src={arrowDown}
                                                alt={t('alt:show_information')}
                                              />
                                            )}
                                          </CustomToggle>
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </Row>
                                  </Card.Header>
                                  <Accordion.Collapse eventKey={maintenance.id}>
                                    <Card.Body className="description-card">
                                      {maintenance.id_status !== 1 ? (
                                        <>
                                          {maintenance.id_status === 4 ? (
                                            <div className="block-observations">
                                              <Row>
                                                <Col xs={12} md={12} className="col-collapse">
                                                  <h6 className="bold">
                                                    {t('maintenanceCompany:observations-block-1')}
                                                  </h6>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col xs={12} md={12} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t('maintenanceCompany:name-workshop')}
                                                  </p>
                                                  <p className="txt">
                                                    {maintenance.workshop
                                                      ? maintenance.workshop
                                                      : ''}
                                                  </p>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col xs={12} md={12} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t(
                                                      'maintenanceCompany:observations-mechanics'
                                                    )}
                                                  </p>
                                                  <p className="txt observations-mechanics">
                                                    {maintenance.mechanics_observations}
                                                  </p>
                                                </Col>
                                              </Row>
                                            </div>
                                          ) : (
                                            <div className="block-observations">
                                              <Row>
                                                <Col xs={12} md={12} className="col-collapse">
                                                  <h6 className="bold">
                                                    {t('maintenanceCompany:data-service')}
                                                  </h6>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col xs={12} md={3} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t('maintenanceCompany:name-workshop')}
                                                  </p>
                                                  <p className="txt">
                                                    {maintenance.workshop
                                                      ? maintenance.workshop
                                                      : ''}
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={3} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t('maintenanceCompany:address')}
                                                  </p>
                                                  <p className="txt">
                                                    {maintenance.workshop
                                                      ? maintenance.address
                                                      : ''}
                                                  </p>
                                                </Col>
                                                <Col xs={6} md={3} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t('maintenanceCompany:date-service')}
                                                  </p>
                                                  <p className="txt">
                                                    <Moment format="DD/MM/YYYY">
                                                      {maintenance.date_service_process}
                                                    </Moment>
                                                  </p>
                                                </Col>
                                                <Col xs={6} md={3} className="col-collapse">
                                                  <p className="second title-2">
                                                    {t('maintenanceCompany:hour-service')}
                                                  </p>
                                                  <p className="txt">
                                                    <Moment format="hh:mm a">
                                                      {maintenance.date_service_process}
                                                    </Moment>
                                                  </p>
                                                </Col>
                                              </Row>
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        ''
                                      )}
                                      <div>
                                        <Row>
                                          <Col xs={12} md={12}>
                                            <h6 className="bold">
                                              {t('maintenanceCompany:observations')}
                                            </h6>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col xs={12} md={3} className="col-collapse">
                                            <p className="title-2">{t('name')}</p>
                                            <p className="txt">
                                              {`${maintenance.drivername} ${maintenance.driverlast_name}`}
                                            </p>
                                          </Col>
                                          <Col xs={12} md={3} className="col-collapse">
                                            <p className="title-2">
                                              {t('maintenanceCompany:service-type')}
                                            </p>
                                            <p className="txt">
                                              {maintenance.service_type.split(',')[0]}
                                              {maintenance.service_type.split(',').length > 1 ? (
                                                <OverlayTrigger
                                                  placement="top"
                                                  className="tooltip-info vehicle"
                                                  id="vehicle"
                                                  delay={{ show: 50, hide: 500 }}
                                                  overlay={(componentProps) =>
                                                    RenderTooltip({
                                                      ...componentProps,
                                                      items: maintenance.service_type.split(','),
                                                      id: 'tooltip-type-services',
                                                      classtxt: 'tooltip-txt-info',
                                                    })
                                                  }
                                                >
                                                  <img
                                                    className="info-maintenance-company"
                                                    src={eye}
                                                    alt={t('alt:tooltip')}
                                                  />
                                                </OverlayTrigger>
                                              ) : (
                                                ''
                                              )}
                                            </p>
                                          </Col>
                                          <Col xs={6} md={3} className="col-collapse">
                                            <p className="title-2">{t('date-hour-service')}</p>
                                            <p className="txt">
                                              <Moment format="DD/MM/YYYY">
                                                {maintenance.date_service}
                                              </Moment>{' '}
                                              <Moment
                                                date={hourChange(maintenance.service_hours)}
                                                format="hh:mm a"
                                              />
                                            </p>
                                          </Col>
                                          <Col xs={6} md={3} className="col-collapse">
                                            <p className="second title-2">{t('image')}</p>
                                            <p className="txt">
                                              {maintenance.image ? (
                                                <a
                                                  className="a-vehicle"
                                                  href={`${urlPublicS3()}/${maintenance.image}`}
                                                  target="_blank"
                                                  rel="noreferrer"
                                                >
                                                  {t('see-image')}
                                                </a>
                                              ) : (
                                                t('without-image')
                                              )}
                                            </p>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col xs={12} md={12} className="col-collapse">
                                            <p className="second title-2">
                                              {t('maintenanceCompany:description-card')}
                                            </p>
                                            <p className="txt observations-mechanics">
                                              {maintenance.description}
                                            </p>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Card.Body>
                                  </Accordion.Collapse>

                                  {maintenance.id_status !== 3 ? (
                                    maintenance.id_status !== 4 ? (
                                      maintenance.id_status !== 5 ? (
                                        <div className="block-btn-opt">
                                          <Button
                                            className="cancel-btn"
                                            onClick={() => confirmCancel(maintenance.id)}
                                          >
                                            {t('cancel-service')}
                                          </Button>
                                        </div>
                                      ) : (
                                        <div className="block-btn-opt">
                                          <Button
                                            className="cancel-btn"
                                            onClick={() =>
                                              redirectJobRequest(t('routers:JobRequests'))
                                            }
                                          >
                                            {t('reschedule-job')}
                                          </Button>
                                        </div>
                                      )
                                    ) : (
                                      <>
                                        {maintenance.company_observations === null ? (
                                          <div className="block-btn-opt">
                                            <Button
                                              className=""
                                              onClick={() => {
                                                aproveService(maintenance.id);
                                                setSuccessfully(true);
                                              }}
                                            >
                                              {t('approve-service')}
                                            </Button>
                                          </div>
                                        ) : (
                                          ''
                                        )}
                                      </>
                                    )
                                  ) : (
                                    ''
                                  )}
                                </Card>
                              </div>
                            )
                        )}
                      </Accordion>
                      <Pagination
                        className="col-12"
                        size="small"
                        defaultCurrent={1}
                        total={maintenancesCompany.length}
                        defaultPageSize={cardPerPage}
                        current={currentPage}
                        onChange={handleChange}
                      />
                      {messageAlert && (
                        <Alert variant="warning">
                          <Alert.Heading>
                            <img src={infoAlert} alt={t('alt:notification')} />
                            <strong>{t('alert:title-info-contact')}</strong>
                          </Alert.Heading>
                          <p>{t('alert:profile-company')}</p>
                        </Alert>
                      )}
                    </>
                  )}
                </Row>
              </div>
            </>
          )}
        </>
      )}
    </>
  </Template>
);
}

Maintenance.propTypes = {
t: PropTypes.func.isRequired,
};

export default withTranslation(['maintenance', 'maintenanceCompany', 'alert', 'routers', 'alt'])(
Maintenance
);
